"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoCroupierDealCommand = void 0;
const draw_deck_croupier_action_1 = require("../../actions/draw-deck-croupier-action");
class AutoCroupierDealCommand {
    static isCommand(command) {
        return command instanceof AutoCroupierDealCommand;
    }
    executeCommand(commandHash, existingDeal, instant, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const drawDeckCroupierAction = new draw_deck_croupier_action_1.DrawDeckCroupierAction(context.playerManager.board);
            drawDeckCroupierAction.execute();
            yield context.dealProcessor.disclosePendingCards(commandHash, existingDeal);
            drawDeckCroupierAction.resolve();
            context.eventQueue.enqueue({
                type: "onDrawDeckCroupier",
                instant,
                payload: {
                    croupier: context.playerManager.croupier.clone(),
                    cardIndex: drawDeckCroupierAction.cardIndex,
                },
            });
        });
    }
}
exports.AutoCroupierDealCommand = AutoCroupierDealCommand;
